import { atomWithKey as atom } from "./atomWithKey";
import { StationsListType } from "../Types/Index";

export const stopsResponseAtom = atom<StationsListType>({
    key: "stopsResponseAtom",
    default: []
})

export const favoritesStateAtom = atom<string[]>({
    key: "favoritesStateAtom",
    default: [],
});

export const updatedStopsAtom = atom<any>({
    key: "updatedStopsAtom",
    default: []
});

export const subStationDropdownAtom = atom<{[key: string]: boolean}>({
    key: "subStationDropdownAtom",
    default: {}
});